import React, { useEffect } from "react";
import Delta from "./Delta/Delta";
import Camera from "./Camera/Camera";
import StereoCamera from "./StereoCamera/StereoCamera";
import { useDevice, useDevices } from "../../Api/newSockets.api";
import JetsonNano from "./JetsonNano/JetsonNano";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import { savePathToLocalStorage } from "../../utils/helpers";
import { DeviceTypeId } from "../../constants/deviceTypes";

type Props = {
  match: any;
};

const DeviceDetails = (props: Props) => {
  savePathToLocalStorage();

  const deviceId = Number.parseInt(props.match.params.deviceId, 10);
  const { devices, socket, connected } = useDevices();
  const { getDevice } = useDevice();
  const { device } = getDevice(deviceId);

  // Request devices when socket is connected but list is empty (e.g. after reconnect or direct nav)
  useEffect(() => {
    if (connected && socket && (!devices || !devices.length) && !isNaN(deviceId)) {
      socket.emit("getDevices");
    }
  }, [connected, socket, devices, deviceId]);

  const renderTabs = (device: any) => {
    switch (device.deviceTypes.id) {
      case DeviceTypeId.HOST:
        return <JetsonNano device={device} />;
      case DeviceTypeId.CAMERA:
        return <Camera device={device} />;
      case DeviceTypeId.STEREO_CAMERA:
        return <StereoCamera device={device} />;
      case DeviceTypeId.PLC:
        return <Delta device={device} />;
      case DeviceTypeId.ROBOT_ARM:
        return <Delta device={device} />;
      case DeviceTypeId.REST:
        return <Delta device={device} />;
      default:
        return <Delta device={device} />;
    }
  };

  return device ? (
    <div className="devices">{renderTabs(device)}</div>
  ) : (
    <LoadingSpinner />
  );
};

export default DeviceDetails;
